import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import RightContent from 'components/GlobalHeader/RightContent';
import { getSmallLogoImage } from 'services/axios';
import styles from './index.module.less';

export default class TopNavHeader extends PureComponent {
  render() {
    const { theme, contentWidth, collapsed, toggleMenuCollapse } = this.props;
    return (
      <div
        className={`${styles.head} ${theme === 'light' ? styles.light : ''}`}
      >
        <div
          ref={ref => {
            this.maim = ref;
          }}
          className={`${styles.main} ${
            contentWidth === 'Fixed' ? styles.wide : ''
          }`}
        >
          <div className={styles.left}>
            <div className={styles.logo} key="logo" id="logo">
              <Link to="/">
                <img src={getSmallLogoImage()} alt="logo" />
              </Link>
            </div>
            <span>
              <Icon
                className={styles.trigger}
                type={collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={toggleMenuCollapse}
              />
            </span>
          </div>
          <RightContent {...this.props} />
        </div>
      </div>
    );
  }
}
